import './style.scss';
import { generalHrefHoc } from './GeneralHrefComponent';
import NewTabHref from './GeneralHrefComponent';

const ClientHrefAdmin = ({ clientId, ...rest }) => {
  return <NewTabHref {...rest} link={`/administration/users/edit/${clientId}`} />
}

export default generalHrefHoc(ClientHrefAdmin);